import c from "../common"

export default {
    ModifyList: c.ModifyPartnersList.en,
    Partner: "Partner",
}